import React from 'react';
import {StyleSheet, View, StyleProp, ViewStyle} from 'react-native';
import {
  SignUpIcon,
  HomeIcon,
  HistoryIcon,
  PlusIcon,
  PersonIcon,
  SearchIcon,
  SettingsIcon,
  CrossIcon,
  StarFilledIcon,
  StarIcon,
  HeaderFilledIcon,
  PlusCircleArrowsIcon,
  ChevronIcon,
  HeartIcon,
  MoreCircleIcon,
  ChatIcon,
  CallIcon,
  CheckIcon,
  CancelIcon,
  EditIcon,
  SendIcon,
  CommentIcon,
  MinusCircleIcon,
  HideIcon,
  PostIcon,
  YenIcon,
  CallEndIcon,
} from './components';

export type IconName =
  | 'sign-up'
  | 'home'
  | 'history'
  | 'plus'
  | 'person'
  | 'search'
  | 'settings'
  | 'cross'
  | 'star-filled'
  | 'star'
  | 'heart-filled'
  | 'plus-circle-arrows'
  | 'chevron'
  | 'heart'
  | 'more-circle'
  | 'chat'
  | 'call'
  | 'check'
  | 'cancel'
  | 'edit'
  | 'send'
  | 'comment'
  | 'minus-circle'
  | 'hide'
  | 'post'
  | 'yen'
  | 'call-end';

export type IconProps = {
  name: IconName;
  color?: string;
  size: number;
  style?: StyleProp<ViewStyle>;
};

export const Icon: React.FC<IconProps> = ({style, ...others}) => {
  return (
    <View style={[styles.container, style || {}]}>
      {others.name === 'sign-up' ? <SignUpIcon {...others} /> : null}
      {others.name === 'home' ? <HomeIcon {...others} /> : null}
      {others.name === 'history' ? <HistoryIcon {...others} /> : null}
      {others.name === 'plus' ? <PlusIcon {...others} /> : null}
      {others.name === 'person' ? <PersonIcon {...others} /> : null}
      {others.name === 'search' ? <SearchIcon {...others} /> : null}
      {others.name === 'settings' ? <SettingsIcon {...others} /> : null}
      {others.name === 'cross' ? <CrossIcon {...others} /> : null}
      {others.name === 'star-filled' ? <StarFilledIcon {...others} /> : null}
      {others.name === 'star' ? <StarIcon {...others} /> : null}
      {others.name === 'heart-filled' ? <HeaderFilledIcon {...others} /> : null}
      {others.name === 'plus-circle-arrows' ? (
        <PlusCircleArrowsIcon {...others} />
      ) : null}
      {others.name === 'chevron' ? <ChevronIcon {...others} /> : null}
      {others.name === 'heart' ? <HeartIcon {...others} /> : null}
      {others.name === 'more-circle' ? <MoreCircleIcon {...others} /> : null}
      {others.name === 'chat' ? <ChatIcon {...others} /> : null}
      {others.name === 'call' ? <CallIcon {...others} /> : null}
      {others.name === 'check' ? <CheckIcon {...others} /> : null}
      {others.name === 'cancel' ? <CancelIcon {...others} /> : null}
      {others.name === 'edit' ? <EditIcon {...others} /> : null}
      {others.name === 'send' ? <SendIcon {...others} /> : null}
      {others.name === 'comment' ? <CommentIcon {...others} /> : null}
      {others.name === 'minus-circle' ? <MinusCircleIcon {...others} /> : null}
      {others.name === 'hide' ? <HideIcon {...others} /> : null}
      {others.name === 'post' ? <PostIcon {...others} /> : null}
      {others.name === 'yen' ? <YenIcon {...others} /> : null}
      {others.name === 'call-end' ? <CallEndIcon {...others} /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
});
